<div class="container-fluid">

	<div class="row row-header">
		<div class="col">

			<div class="breadcrumbs"></div>
			<div data-testid="SUBSYS1_LEGALTERMS_LOGO_TXT" class="logo-full-text">
				{{ labels().APP_LOGO_TEXT }}
			</div>

			<h1 data-testid="SUBSYS1_LEGALTERMS_TITLE_TXT">{{ labels().LEGAL_TERMS_COMPONENT_TITLE }}</h1>
			<p data-testid="SUBSYS1_LEGALTERMS_SUBTITLE_TXT">{{ labels().LEGAL_TERMS_COMPONENT_SUBTITLE }}</p>

		</div>
	</div>

	<form>
		<div class="row row-contents">
			<div class="col-12">

				<div class="swiper-container legal-swiper" style="overflow: hidden;">
					<!-- Additional required wrapper -->
					<div class="swiper-wrapper">

						@if (EULAForm) {
						<!-- Slide EndUserLicenseAgreement -->
						<div class="swiper-slide">

							<p data-testid="SUBSYS1_LEGALTERMS_EULA_DATE_TXT">
								{{ labels().LEGAL_TERMS_COMPONENT_EFFECTIVE_DATE }}: {{ EULAForm.effectiveDate | convertDate:true }}
								<span data-testid="SUBSYS1_LEGALTERMS_EULA_FORMATDATE_TXT" class="date-format ms-3">
									{{ dateFormat }}
								</span>
							</p>

							<div data-testid="SUBSYS1_LEGALTERMS_EULA_BOX" class="swiper-slide-content" [innerHTML]="EULAForm.text"
								(scroll)="onEULAScroll($event)"></div>

							@if (EULAForm.eula1) {
							<div class="form-group switch-custom-container">
								<label class="switch" aria-label="eula acceptance">
									<input data-testid="SUBSYS1_LEGALTERMS_EULA_INPUT" #eula1 type="checkbox"
										[disabled]="!EULAForm.endScroll" (click)="acceptEULA(eula1.checked)"
										(keypress)="acceptEULA(eula1.checked)" />
									<span></span>
								</label>
								<p data-testid="SUBSYS1_LEGALTERMS_EULA_TXT" [innerHTML]="EULAForm.eula1"></p>
							</div>
							}

							@if (EULAForm.add_msg) {
							<div>
								<p data-testid="SUBSYS1_LEGALTERMS_EULA_ADDMSG_TXT" [innerHTML]="EULAForm.add_msg"></p>
							</div>
							}

						</div>
						}


						@if (PPForm) {
						<!-- Slide PrivacyPolicy -->
						<div class="swiper-slide">

							<p data-testid="SUBSYS1_LEGALTERMS_PRIVACY_DATE_TXT">
								{{ labels().LEGAL_TERMS_COMPONENT_EFFECTIVE_DATE }}: {{ PPForm.effectiveDate | convertDate:true }}
								<span data-testid="SUBSYS1_LEGALTERMS_PRIVACY_FORMATDATE_TXT" class="date-format ms-3">
									{{ dateFormat }}
								</span>
							</p>

							<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_BOX" class="swiper-slide-content" [innerHTML]="PPForm.text"
								(scroll)="onPPScroll($event)"></div>

							@if (PPForm.ack) {
							<div class="form-group switch-custom-container">
								<label class="switch" aria-label="pp acceptance">
									<input data-testid="SUBSYS1_LEGALTERMS_PRIVACY_INPUT" #privacypolicy type="checkbox"
										[disabled]="!PPForm.endScroll" (click)="acceptPrivacyPolicy(privacypolicy.checked)"
										(keypress)="acceptPrivacyPolicy(privacypolicy.checked)" />
									<span></span>
								</label>
								<p data-testid="SUBSYS1_LEGALTERMS_PRIVACY_TXT" [innerHTML]="PPForm.ack"></p>
							</div>
							}

							@if (PPForm.marketingTxt) {
							<div class="form-group">
								<p data-testid="SUBSYS1_LEGALTERMS_PRIVACY_MARKETING_TXT" [innerHTML]="PPForm.marketingTxt"></p>
								<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_MARKETING_YES"
									class="custom-control custom-radio custom-control-inline" (click)="acceptMarketing(true)"
									(keydown)="acceptMarketing(true)">
									<input data-testid="SUBSYS1_LEGALTERMS_PRIVACY_MARKETING_YES_INPUT" type="radio" id="radio-1a"
										name="radio-1" class="custom-control-input" [value]="!!PPForm.marketingValue"
										[checked]="!!PPForm.marketingValue" [disabled]="!PPForm.endScroll || !PPForm.isAccepted" />
									<label class="custom-control-label" for="radio-1a" id="marketing-yes">{{ yesItem }}</label>
								</div>
								<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_MARKETING_NO"
									class="custom-control custom-radio custom-control-inline" (click)="acceptMarketing(false)"
									(keydown)="acceptMarketing(false)">
									<input data-testid="SUBSYS1_LEGALTERMS_PRIVACY_MARKETING_NO_INPUT" type="radio" id="radio-1b"
										name="radio-1" class="custom-control-input" [value]="PPForm.marketingValue === false"
										[checked]="PPForm.marketingValue === false" [disabled]="!PPForm.endScroll || !PPForm.isAccepted" />
									<label class="custom-control-label" for="radio-1b" id="marketing-no">{{ noItem }}</label>
								</div>
							</div>
							}

							@if (PPForm.profilationTxt) {
							<div class="form-group">
								<p data-testid="SUBSYS1_LEGALTERMS_PRIVACY_PROFILATION_TXT" [innerHTML]="PPForm.profilationTxt"></p>
								<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_PROFILATION_YES"
									class="custom-control custom-radio custom-control-inline" (click)="acceptProfilation(true)"
									(keydown)="acceptProfilation(true)">
									<input data-testid="SUBSYS1_LEGALTERMS_PRIVACY_PROFILATION_YES_INPUT" type="radio" id="radio-2a"
										name="radio-2" class="custom-control-input" [value]="!!PPForm.profilationValue"
										[checked]="!!PPForm.profilationValue" [disabled]="!PPForm.endScroll || !PPForm.isAccepted" />
									<label class="custom-control-label" for="radio-2a" id="profilation-yes">{{ yesItem }}</label>
								</div>
								<div data-testid="SUBSYS1_LEGALTERMS_PRIVACY_PROFILATION_NO"
									class="custom-control custom-radio custom-control-inline" (click)="acceptProfilation(false)"
									(keydown)="acceptProfilation(false)">
									<input data-testid="SUBSYS1_LEGALTERMS_PRIVACY_PROFILATION_NO_INPUT" type="radio" id="radio-2b"
										name="radio-2" class="custom-control-input" [value]="PPForm.profilationValue === false"
										[checked]="PPForm.profilationValue === false"
										[disabled]="!PPForm.endScroll || !PPForm.isAccepted" />
									<label class="custom-control-label" for="radio-2b" id="profilation-no">{{ noItem }}</label>
								</div>
							</div>
							}

						</div>
						}


						<!-- Slide DataProcessAgreement -->
						@if (DPAForm) {
						<div class="swiper-slide">

							<p data-testid="SUBSYS1_LEGALTERMS_DPA_DATE_TXT">
								{{ labels().LEGAL_TERMS_COMPONENT_EFFECTIVE_DATE }}: {{ DPAForm.effectiveDate | convertDate:true }}
								<span data-testid="SUBSYS1_LEGALTERMS_DPA_FORMATDATE_TXT" class="date-format ms-3">
									{{ dateFormat }}
								</span>
							</p>

							<div data-testid="SUBSYS1_LEGALTERMS_DPA_BOX" class="swiper-slide-content" [innerHTML]="DPAForm.text"
								(scroll)="onDPAScroll($event)"></div>

							@if (DPAForm.ack) {
							<div class="form-group switch-custom-container">
								<label class="switch" aria-label="dpa acceptance">
									<input data-testid="SUBSYS1_LEGALTERMS_DPA_INPUT" #dpa type="checkbox" [disabled]="!DPAForm.endScroll"
										[checked]="DPAForm.isAccepted" (click)="acceptDataProcessAgreement(dpa.checked)"
										(keypress)="acceptDataProcessAgreement(dpa.checked)" />
									<span></span>
								</label>
								<p data-testid="SUBSYS1_LEGALTERMS_DPA_TXT" [innerHTML]="DPAForm.ack"></p>
							</div>
							}

						</div>
						}

					</div>
				</div>

			</div>

			<div class="col-8">
				<p data-testid="SUBSYS1_LEGALTERMS_LEGALSENTENCE_TXT">{{ labels().LEGAL_TERMS_COMPONENT_LEGAL_SENTENCE }}</p>
			</div>


			<div class="col-12 btn-container">

				<button data-testid="SUBSYS1_LEGALTERMS_NEXT_BTN" id="next-send-button" type="button" class="btn btn-primary"
					[disabled]="isNextDisabled" (click)="nextOrSend()">
					<span class="pe-3">{{ mySwiper?.activeIndex + 1 }}/{{ mySwiper?.slides.length }}</span>
					&nbsp;
					<span>{{ nextOrSendButton }}</span>
				</button>

			</div>
		</div>
	</form>

</div>